import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  height: string
  color?: string
  className?: string
}

export const VerticalDivider: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        height: ${props.height};
        width: 1px;
        border-right: 1px solid ${props.color || colors.border};
      `}
      className={props.className}
    />
  )
}
